import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";
import moment from "moment";
const initialState = {
  manager: null,
  defaultFileStatus: null,
  defaultFolders: null,
  registryRights: [],
  availableStatuses: null,
  projectTasks: [],
  originalData: [],
  table: {
    search: "",
    limit: 11,
    page: 1,
    pages: 1,
    sort: "",
    data: [],
    searchFields: [
      { key: "manufacturerIndex", name: "global:parts.manufacturerIndex" },
      { key: "[ma].entryName", name: "global:parts.name" },
      { key: "name", name: "global:parts.name" },
      { key: "[pm].modelName", name: "global:parts.modelName" },

      { key: "[s].name", name: "global:project.status" },
    ],
    selectedSearchFields: [
      "manufacturerIndex",
      "[ma].entryName",
      "name",
      "[s].name",
      "[pm].modelName",
    ],
    dictionaryFields: [],
    startDate: null,
    endDate: null,
    url: "part",
  },
};

const partsReducer = createSlice({
  name: "partsReducer",
  initialState,
  reducers: {
    setRegistryRights: (state, { payload }) => {
      state.registryRights = payload;
    },
    updateManager: (state, { payload }) => {
      state.manager = payload;
    },
    updateDefaultFileStatus: (state, { payload }) => {
      state.defaultFileStatus = payload;
    },
    updateDefaultFolders: (state, { payload }) => {
      state.defaultFolders = payload;
    },
    updateAvailableStatuses: (state, { payload }) => {
      state.availableStatuses = payload;
    },
    updateRegistry: (state, { payload }) => {
      state.table = { ...state.table, ...payload };
    },

    clearRegistry: () => initialState,
  },
  extraReducers: {},
});

export const {
  updateRegistry,
  clearRegistry,
  updateManager,
  updateDefaultFileStatus,
  updateDefaultFolders,
  updateAvailableStatuses,
  setRegistryRights,
} = partsReducer.actions;

export default partsReducer.reducer;
